export default __webpack_public_path__ + "static/media/LOMITO-NUGGETs.f47afa57.png";